import { useEffect } from 'react';
import { useThemeStore, applyTheme, activeCustomTheme } from '../lib/stores';
import { isThemePreviewing } from '../lib/customTheme';

/**
 * Applies the user's selected theme (palette / mode / contrast + the active
 * custom theme's inline tokens) to <html>, and tracks the OS preference on
 * 'system'. Stands down while a live cross-window PREVIEW is active so the
 * preview wins. Mounted in the app Layout AND in the standalone theme-editor
 * shell, so both windows render the user's real theme. Renders nothing.
 */
export function ThemeApplier() {
  const palette = useThemeStore((s) => s.palette);
  const mode = useThemeStore((s) => s.mode);
  const contrast = useThemeStore((s) => s.contrast);
  const customThemes = useThemeStore((s) => s.customThemes);
  const activeCustomId = useThemeStore((s) => s.activeCustomId);

  useEffect(() => {
    const custom = activeCustomTheme({ palette, customThemes, activeCustomId });
    const apply = () => { if (!isThemePreviewing()) applyTheme(palette, mode, contrast, custom); };
    apply();
    if (mode === 'system') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      mq.addEventListener('change', apply);
      return () => mq.removeEventListener('change', apply);
    }
  }, [palette, mode, contrast, customThemes, activeCustomId]);

  return null;
}
